import { defineMessages } from "react-intl";

export const messages = defineMessages({
  errorTitle: "An error has occurred",
  loadError: "The finder could not be loaded. Please try again later.",
  backToWebsite: "Back to main website",
  unexpectedError: "Please send us a message if you continue to see this error.",
  refresh: "Refresh the page",
});
